import React from 'react';
import getLocation from '@atlassian/jira-common-location/src/index.tsx';
import FullPageRedirect from '../full-page-redirect/index.tsx';

const LoginRedirect = (): React.JSX.Element | null => {
	const { href = null } = getLocation() || {};
	if (href && !href.includes('login.jsp')) {
		const encodedRedirectUrl = encodeURIComponent(href);
		return <FullPageRedirect url={`/login.jsp?os_destination=${encodedRedirectUrl}`} />;
	}
	return null;
};

export default LoginRedirect;
